const dteSaleFormat = [
    
    {
        back: 'dte_type_invoice',
        front: 'dteTypeInvoice',
    },
    {
        back: 'dte_type_ticket',
        front: 'dteTypeTicket',
    },
    {
        back: 'emission_date',
        front: 'emissionDate',
    },
    {
        back: 'net_total',
        front: 'netTotal',
    },
    {
        back: 'global_discount_type',
        front: 'globalDiscountType',
    },
    {
        back: 'global_discount_percentage',
        front: 'globalDiscountPercentage',
    },
    {
        back:'global_discount_amount',
        front: 'globalDiscountAmount',
    }
]
export {
    dteSaleFormat,
}